module.exports = __webpack_public_path__ + "img/labBg3.b195631a.png";